module.exports = __webpack_public_path__ + "img/approving.17f413a7.svg";